import axios from "axios";
import qs from "qs";
import global from "../global.js";
import { LnoUrl } from "./noUrl";
import { checkRequest, deleteRequestKey } from "./stopRepeatServer.js"
import { Message } from "element-ui";


const server = axios.create({
  baseURL: global.ip,
  timeout: 65000,
  headers: {
    "content-type": "application/x-www-form-urlencoded;charset=utf-8 ",
  },
});
//GET
const getRequest = function (url) {
  return server({
    method: "get",
    url: url,
  });
};
//POST
const postRequest = function (url, data, config) {
  return server({
    method: "post",
    url: url,
    data: data,
    ...config,
  });
};
//PUT
const putRequest = function (url, data, config) {
  return server({
    method: "put",
    url: url,
    data: data,
    ...config,
  });
};
//DELETE
const deleteRequest = function (url) {
  return server({
    method: "delete",
    url: url,
  });
};

//请求拦截器
server.interceptors.request.use(
  (config) => {
    let uid = JSON.parse(localStorage.getItem("userinfo"))?.uid ?? '';

    if (config.data instanceof FormData) {
      if (!config.data.has('uid')) {
        config.data.append("uid", uid);
      }
    } else {
      config.data = qs.stringify({
        uid,
        ...config.data,
      });
    }

    // 请求时通过设置 config.noStopRepeat = true 可使该重复请求不被中断
    if (!config.noStopRepeat) {  
      //阻止重复请求
      const source = axios.CancelToken.source();
      config.cancelToken = source.token;
      checkRequest(config, source)
    }
    //阻止重复请求

    return config;
  },
  (error) => {
    Message("请求错误");
    return error;
  }
);

//响应拦截器
server.interceptors.response.use(
  (response) => {
    deleteRequestKey(response.config)

    // 请求时通过设置 config.noShowMsg = true 可阻止报错信息
    if (response.config.noShowMsg) {
      return response;
    }

    //添加不要展示的消息提示的url
    const noMessageArr = [...LnoUrl];
    //请求的url
    const noUrl = response.config.url;
    //判断是否为不要展示的url
    if (response.data.code != '0') {
      let errorText = (response.data.data && response.data.data.error) ? ',' + response.data.data.error : '';
      if (response.data.message) {
        console.log(response.data.message, errorText)
        Message({ message: response.data.message, duration: 1000 });
      }
    } else if (!noMessageArr.includes(noUrl) && response.data.message) {
      Message({ message: response.data.message, duration: 1000 });
    }
    return response;
  },
  (error) => {
    console.log(error)
    if (error.message.toString().indexOf('请求被中断') > -1) {
      console.log(error.message)
      return
    }
    deleteRequestKey(error.config)

    if (error.config && error.config.noShowMsg) {
      return error;
    }

    if (!error.response) {
      Message({ message: '网络异常，请检查网络连接', duration: 2000 });
    } else switch (error.response.status) {
      case 404:
        Message({ message: '找不到目标地址，请联系管理员处理', duration: 2000 });
        break;
      case 500:
        Message({ message: '服务异常，请联系管理员处理', duration: 2000 });
        break;
      case 503:
        Message({ message: '服务不可用，请联系管理员处理', duration: 2000 });
        break;
      default:
        Message({ message: error.response.statusText, duration: 2000 });
        break;
    }
    return error;
  }
);
export { server, getRequest, postRequest, putRequest, deleteRequest };
